import { apiService } from '.';
import { ILoginUser, IRegisterUser } from '../shared/types/auth';
import { ResponseData } from '../shared/types/shared';

export const asyncAuthRegister = async (formAuthRegister: IRegisterUser) => {
    return await apiService.post('/api/auth/register', formAuthRegister);
};

export const asyncAuthLogin = async (formAuthLogin: ILoginUser) => {
    return await apiService.post('/api/auth/login', formAuthLogin);
};

export const asyncGetSendCode = async (
    email: string
): Promise<ResponseData | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: ResponseData;
        } = await apiService.get(`/api/auth/send/${email}`);
        return data || { items: [], length: 0 };
    } catch (error) {}
};

export const asyncGetValidateCode = async (
    email: string,
    code: string
): Promise<ResponseData | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: ResponseData;
        } = await apiService.get(`/api/auth/validate/${email}/${code}`);

        return data;
    } catch (error) {}
};
